<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    :title="$t('menu.pages')"
    @change="$emit('input',false)"
  >
    <p class="h5 mb-1">
      {{ `${package.name}  -  ${package.total}` }}
    </p>
    <b-table
      responsive="lg"
      :fields="fields"
      :items="pages"
    />
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="dark"
          @click="$emit('input',false)"
        >
          {{ $t('forms.ok') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BTable,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'

export default {
  name: 'PagesModal',
  components: {
    OkModal,
    BButton,
    BTable,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    package: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      fields: [],
      pages: [],
    }
  },
  watch: {
    package(val) {
      this.pages = val?.pages ?? []
    },
  },
  mounted() {
    this.pages = this.package?.pages ?? []
    this.fields = [
      {
        key: 'page_name',
        label: this.$t('page.name'),
      },
      {
        key: 'expired',
        label: this.$t('page.active'),
        formatter: value => (value ? this.$t('general.no') : this.$t('general.yes')),
      },
    ]
  },

}
</script>
